import React from 'react';
const points = [{
  emoji: '😰',
  text: 'Du kennst das Gefühl, in die Sporthalle zu gehen und nicht genau zu wissen, was heute funktionieren wird.'
}, {
  emoji: '⏱️',
  text: 'Du verlierst zu viel Zeit mit Planung, obwohl du eigentlich nur fertige, gute Stunden brauchst.'
}, {
  emoji: '🌧️',
  text: 'Regen, belegte Halle oder fehlendes Material bringen deine Planung sofort durcheinander.'
}, {
  emoji: '📊',
  text: 'Du möchtest fair bewerten, aber dir fehlen klare Kriterien und einfache Vorlagen.'
}, {
  emoji: '😓',
  text: 'Deine Schüler landen zu oft bei denselben Spielen, weil dir im Alltag die Zeit für neue Ideen fehlt.'
}, {
  emoji: '😩',
  text: 'Du willst professionell unterrichten, aber der Schulalltag frisst deine Energie.'
}];
export function ForWhomSection() {
  return <section className="w-full bg-bg-dark py-16 sm:py-24 px-4" data-id="element-119">
      <div className="max-w-3xl mx-auto" data-id="element-120">
        <div className="text-center mb-12" data-id="element-121">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main mb-4" data-id="element-122">
            👉 Erkennst du dich wieder?
          </h2>
          <p className="text-text-sec text-base sm:text-lg" data-id="element-123">
            Wenn du bei nur einem Punkt nickst, ist dieses Paket für dich
            gemacht.
          </p>
        </div>

        <div className="space-y-4 mb-12" data-id="element-124">
          {points.map((point, i) => <div key={i} className="flex items-center gap-4 sm:gap-6 bg-bg-alt rounded-2xl p-5 sm:p-6 border border-border-light shadow-sm" data-id="element-125">
              <div className="text-3xl sm:text-4xl flex-shrink-0" data-id="element-126">
                {point.emoji}
              </div>
              <p className="text-text-main font-medium text-base sm:text-lg leading-snug" data-id="element-127">
                {point.text}
              </p>
            </div>)}
        </div>

        <div className="text-center max-w-2xl mx-auto" data-id="element-128">
          <p className="text-primary font-serif italic text-xl sm:text-2xl font-bold mb-3" data-id="element-129">
            Du brauchst nicht mehr Material. Du brauchst ein fertiges System.
          </p>
          <p className="text-text-sec text-base sm:text-lg font-medium" data-id="element-130">
            Genau dafür wurde SPORTUNTERRICHT FERTIG entwickelt — ein digitales
            Komplettpaket für Sportlehrer, die weniger improvisieren und besser
            vorbereitet unterrichten wollen.
          </p>
        </div>
      </div>
    </section>;
}